import type { NaturalezaCategoriaEconomica, TipoMovimientoEconomico } from "../../shared/types";

// Copia de solo lectura del mapa del backend (functions/_app/lib/economia.ts)
// — se usa acá únicamente para decidir si mostrar el selector de Categoría/
// Subcategoría según el Tipo elegido en el formulario. La validación real es
// 100% del backend (routes/economia.ts) — esto nunca reemplaza esa validación.
export const NATURALEZA_CATEGORIA: Partial<Record<TipoMovimientoEconomico, NaturalezaCategoriaEconomica>> = {
  "Honorarios Cobrados": "Ingreso",
  "Gasto Recuperado": "Ingreso",
  "Otro Ingreso": "Ingreso",
  "Gasto Adelantado": "Gasto",
  "Pago a Profesional": "Gasto",
  "Otro Egreso": "Gasto",
};
